import { render } from "./DetalleNoticia.vue?vue&type=template&id=33b224c2"
import script from "./DetalleNoticia.vue?vue&type=script&lang=js"
export * from "./DetalleNoticia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__